module.exports = __webpack_public_path__ + "static/media/warning-icon.50a67242.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/warning-icon.png
// module id = 743
// module chunks = 0